import { Component, Output, EventEmitter } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { TraduccionesComponent } from '../../../../Alsa-MA-Angular-utils/src/app/traducciones.component';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var colorLineaClicada: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;

declare var origenParadas1: any;
declare var destinoParadas1: any;
declare var origenParadas2: any;
declare var destinoParadas2: any;

declare var stops: any; // Las paradas a poner en el maps
declare var dibujoStops: any; // El dibujo de las paradas en el mapa
declare var i18nVS: any;

@Component({
    selector: 'app-service-information-paradas',
    templateUrl: './paradas.component.html',
    styleUrls: ['../service-information.component.css']
})

export class ParadasComponent {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = TraduccionesComponent.arrayTraducciones;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output () onLineSelected: EventEmitter<any> = new EventEmitter<any>();

    idLinea = ''; jsonData; paradasCompleto = []; origen = ''; destino = '';
    paradasIda = []; paradasVuelta = [];
    mostrandoIda = true;
    loadingStopsClass = '';
    linesJson;

    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public getBackground() {
        // Los colores de fondo de las paradas nos pueden llegar con el # incluido o sin el desde el back.
        // Para poder poner bien el color hacemos replace de # del 'color' que nos llega y se lo incluimos siempre.
        return this._sanitizer.bypassSecurityTrustStyle("#" + colorLineaClicada.replace("#",""));
    }

    public setBackground(color) {
        return this._sanitizer.bypassSecurityTrustStyle("#" + color.replace("#",""));
    }

    public comprobandoJson (res) {
        try {
            this.jsonData = res;
        } catch (error) {
            this.errorEnElJson();
        }
    }

    public errorEnElJson() {
        console.log('Error en los WS');
        this.onWebServiceError.emit(true);
    }


    /* Muestra las paradas de una linea */
    public showStops (line) {
        // Limpiamos el array de conexiones
        line = this.clearConnections(line);

        this.loadingStopsClass = 'invisible';
        this.idLinea = line.id;

        this.origen = this.lineFirstName(line.outgoing.stops);
        this.destino = this.lineLastName(line.outgoing.stops);

        // Paradas y destinos usados en la tabla de horarios
        origenParadas1 = line.outgoing.lineHeader;
        origenParadas2 = line.return.lineHeader;
        destinoParadas1 = line.outgoing.lineEnd;
        destinoParadas2 = line.return.lineEnd;

        this.paradasIda = line.outgoing.stops;
        this.paradasVuelta = line.return.stops;

        if (this.paradasVuelta != undefined) {
            stops = this.paradasIda.concat(this.paradasVuelta);
        }

        dibujoStops = line.return.traking.concat(line.outgoing.traking);

        nombreOrigen = this.origen;
        nombreDestino = this.destino;

        this.mostrandoIda = true;
    }

    /* Esta funcion quitara del array de conexiones la conexion con la propia linea */
    private clearConnections (line) {
        // Limpiamos las paradas de ida
        var outgoingStops = line.outgoing.stops;
        line.outgoing.stops = this.clearConnectionsStep2(outgoingStops, line.id);

        // De existir limpiamos las paradas de vuelta
        var returnStops = line.return.stops;
        if (returnStops != undefined) {
            line.return.stops = this.clearConnectionsStep2(returnStops, line.id);
        }

        return line;
    }

    // Segundo paso de la funcion clearConnections
    private clearConnectionsStep2 (stops, lineId) {
        var newStops = stops;
        for (let i = 0; i < stops.length; i++) {
            var newConnections = [];
            var originalConnections = stops[i].connections;

            if (typeof originalConnections == 'undefined') {
                originalConnections = newConnections;
            }

            for (let x = 0; x < originalConnections.length; x++) {
                if (originalConnections[x].id != lineId) {
                    newConnections[newConnections.length] = originalConnections[x];
                }
            }

            // Se annaden las conexiones eliminando la propia linea
            newStops[i].connections = newConnections;
        }
        return newStops
    }

    /* Funcion cuando se selecciona una linea desde las conexiones */
    public lineSelected(lineId) {
        // Recorremos el array de lineas buscando la clicada
        for (var i = 0; i < this.linesJson.length; i++) {
            if (this.linesJson[i].id == lineId) {
                this.onLineSelected.emit( this.linesJson[i] );
                break;
            }
        }
    }

    public setTraducciones() {
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
        }
    }

    // Devuelve true si lo que se esta mostrando actualmente es la id
    public mostrandoIdaFunction () {
        return this.mostrandoIda;
    }

    public mostrarIda () {
        this.mostrandoIda = true;
    }

    public mostrarVuelta () {
        this.mostrandoIda = false;
    }

    public getConectionsName(conectionName) {
        conectionName = conectionName.split(" ");
        return conectionName[0];
    }

    public lineLastName(array) {
        if (array.length > 0) {
            return array[array.length - 1].name;
        } else {
            return '';
        }
    }

    public lineFirstName(array) {
        if (array.length > 0) {
            return array[0].name;
        } else {
            return '';
        }
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.setTraducciones();
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private _sanitizer: DomSanitizer) { }
}



// WEBPACK FOOTER //
// ./src/app/paradas/paradas.component.ts